import { Reveal } from "../site/Reveal";

const STRIP = [
  { label: "Anno di costituzione", value: "2019", sub: "Radicamento territoriale" },
  { label: "Capitale sociale", value: "€ 257.000", sub: "Interamente versato" },
  { label: "Attestazione SOA", value: "OG 1 · Cl. II", sub: "Lavori pubblici fino a € 516.000" },
  { label: "Regolarità lavoro", value: "DURC in regola", sub: "" },
];

const formatEur = (v) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v);

export const TechHero = () => {
  const cards = [
    ...STRIP,
    {
      label: "Valore opere realizzate",
      value: "Oltre € 7,8 Mln",
      sub: "Lavori realizzati dal 2019 ad oggi",
    },
  ];

  return (
  <section id="top" data-testid="hero-section" className="relative py-20 md:py-28 bg-white border-b border-slate-200 overflow-hidden">
    <img
      src="/assets/cantiere-hero.webp"
      alt=""
      aria-hidden="true"
      className="absolute inset-0 w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-white/80" aria-hidden="true" />
    <div className="absolute inset-0 eng-grid" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-6 relative">
      <div className="max-w-4xl">
        <Reveal>
          <div data-testid="hero-badge" className="inline-flex items-center gap-2 px-3 py-1 bg-slate-100 border border-slate-300 text-slate-700 text-xs font-mono uppercase tracking-wider mb-6">
            <span className="w-2 h-2 bg-blue-600" />
            Attestazione SOA Operativa · Commesse Pubbliche &amp; Civili
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="text-4xl sm:text-6xl md:text-7xl font-extrabold tracking-[-0.03em] text-slate-950 leading-[1.04] mb-6">
            Certezze Strutturali.<br />Esecuzione d'Impresa.
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-lg md:text-xl text-slate-600 max-w-2xl leading-relaxed mb-10">
            Da anni sul territorio con committenti storici e certificazioni che garantiscono la massima
            qualità esecutiva: opere di condomini, ristrutturazioni di appartamenti privati e grandi appalti.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
            <a href="#contact" data-testid="hero-cta-primary" className="px-8 py-4 bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs uppercase tracking-widest text-center transition-colors">
              Richiedi Offerta &amp; Quadro Tecnico
            </a>
            <a href="#dati" data-testid="hero-cta-secondary" className="px-8 py-4 bg-slate-100 hover:bg-slate-200 border border-slate-300 text-slate-800 font-bold text-xs uppercase tracking-widest text-center transition-colors">
              Verifica Attestazioni SOA
            </a>
          </div>
        </Reveal>
      </div>

      <div className="mt-16 pt-10 border-t border-slate-200 grid grid-cols-2 md:grid-cols-5 gap-6">
        {cards.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.08}>
            <div data-testid={`hero-stat-${i}`} className="bg-slate-50 p-5 border border-slate-200 h-full">
              <div className="text-xs font-mono text-slate-600 uppercase">{s.label}</div>
              <div className="text-xl font-extrabold text-slate-900 mt-1">{s.value}</div>
              {s.sub && <div className="text-[11px] text-slate-600 mt-1">{s.sub}</div>}
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
